import colors from '../components/elementsDS/utilsStyle/PaletteColor';
import typography from '../components/elementsDS/utilsStyle/Typography';

// Tema para Farmacias La Arboleda
const theme = {
  typography: {
    fontFamily: `${typography.fontPrimary}`,
    fontFamilyBemio: `${typography.fontSecondary}`,
    fontSize: '16px',
    fontSizeSmall: '13px',

  },
  colors: {
    // primary colors
    primary: `${colors.pblue}`,
    primaryLight: `${colors.pLight}`,
    primaryDeep: `${colors.pDeep}`,
    primaryAccent: `${colors.pAccent}`,
    primaryAccent2: `${colors.pAccent2}`,
    primaryAccent3: `${colors.pAccent3}`,
    primaryComplementary1: `${colors.pBg1}`,
    primaryComplementary2: `${colors.pBg2}`,
    // accent opacity
    primaryAccentO: `${colors.pAccentO}`,
    // secondary colors
    secondary: `${colors.syellow}`,
    secondaryLight: `${colors.sLight}`,
    secondaryDeep: `${colors.sDeep}`,
    secondaryAccent: `${colors.sAccent}`,
    secondaryComplementary1: `${colors.sBg1}`,
    secondaryComplementary2: `${colors.sBg2}`,
    // state colors
    success: `${colors.success}`,
    successLight: `${colors.successLight}`,
    successDeep: `${colors.successDeep}`,
    warning: `${colors.warning}`,
    warningLight: `${colors.warningLight}`,
    warningDeep: `${colors.warningDeep}`,
    danger: `${colors.danger}`,
    dangerLight: `${colors.dangerLight}`,
    dangerDeep: `${colors.dangerDeep}`,
    info: `${colors.blueBright}`,
    infoLight: `${colors.blueBrightLight}`,
    infoDeep: `${colors.blueBrightDeep}`,
    // neutral colors
    light: `${colors.white}`,
    lightLight: `${colors.grayLight}`,
    lightDeep: `${colors.gray1}`,
    gray: `${colors.gray}`,
    grayLight: `${colors.gray2}`,
    grayDeep: `${colors.dark1}`,
    dark: `${colors.dark}`,
    darkLight: `${colors.gray}`,
    darkDeep: `${colors.black}`,

  },
  borders: {
    default: `1px solid ${colors.PictonBlue}`,
    rounded: '8px solid #ccc', // ejemplo de un borde redondeado
    none: 0,
    radius: '8px',
    radiusSmall: '4px',
    // ... otros estilos de borde
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.2)',
  },
  paddings: {
    small: '8px',
    medium: '16px',
    large: '24px',
    // ... otros valores de padding
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '20px',
    // ... otros valores de border-radius
  },
  opacities: {
    low: '0.3',
    medium: '0.6',
    high: '0.9',
    // ... otros valores de opacidad
  },
  breakpoints: {
    small: '576px',
    medium: '768px',
    large: '992px',
    xlarge: '1200px',
    // ... otros breakpoints
  },
  space: [
    '4px',
    '8px',
    '12px',
    '16px',
    '24px',
    '32px',
    '48px',
    '64px',
    '96px',
    '128px',
    '192px',
    '256px',
    '384px',
  ],
};

export default theme;
